import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import ListItemIcon from '@mui/material/ListItemIcon';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CommonButton from '../common/CommonButton/CommonButton';
import PlusOneIcon from '@mui/icons-material/PlusOne';

const Library = () => {
    

    const arrowButtonStyles = {
        padding: 0,
        margin: 0,
        minWidth: '0px',
        position: 'relative',
        left: '2px',
    }

    const filterButtonStyles = {
        border: '2px solid #E0E3E5',
        '& span': {
            color: '#B4B5B6', marginLeft: '3px'
        },
        '&:hover': {
            backgroundColor: '#D8E6F0',
            border: 'solid 2px #C6D7E2',
            color: '#005786'
        },
        '&:hover span': {
            color: '#005786', marginLeft: '3px'
        },
        '&:focus': {
            border: '3px solid #C6D7E2',
            outline: 'none',
        }

        
    };
    return (
        <Grid item xs={12} style={ { padding: '20px' } }>
            <h2>Library</h2>

            <h3>primary</h3>

            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        Default, <br /> hover, <br /> pressed <br /> and focused
                    </Grid>
                    <Grid item xs={3}>
                        <CommonButton
                            variant="contained"
                            size="medium"
                        >
                            Button
                        </CommonButton>
                    </Grid>
                    <Grid item xs={3}>
                        <CommonButton
                            variant="contained"
                            size="medium"
                        >
                            <ListItemIcon>
                                <ArrowBackIcon />
                            </ListItemIcon>
                            Button
                        </CommonButton>
                    </Grid>
                    <Grid item xs={3}>
                        <CommonButton
                            variant="contained"
                            size="medium"
                        >
                            Button
                            <ListItemIcon>
                                <ArrowBackIcon />
                            </ListItemIcon>
                        </CommonButton>
                    </Grid>                       
                </Grid>
            </Box>
            <br />
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        Disabled
                    </Grid>
                    <Grid item xs={3}>
                        <CommonButton
                            variant="contained"
                            size="medium"
                            disabled={true}
                        >
                            Button
                        </CommonButton>
                    </Grid>
                    <Grid item xs={3}>
                        <CommonButton
                            variant="contained"
                            size="medium"
                            disabled={true}
                        >
                            <ListItemIcon>
                                <ArrowBackIcon />
                            </ListItemIcon>
                            Button
                        </CommonButton>
                    </Grid>
                    <Grid item xs={3}>
                        <CommonButton
                            variant="contained"
                            size="medium"
                            disabled={true}
                        >
                            Button
                            <ListItemIcon>
                                <ArrowBackIcon />
                            </ListItemIcon>
                        </CommonButton>
                    </Grid>                       
                </Grid>
            </Box>
            <br />
            <h3>secondary</h3>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        Default, <br /> hover, <br /> pressed <br /> and focused
                    </Grid>
                    <Grid item xs={3}>
                        <CommonButton
                            variant="contained"
                            size="medium"
                            color="secondary"
                        >
                            Button
                        </CommonButton>
                    </Grid>
                    <Grid item xs={3}>
                        <CommonButton
                            variant="contained"
                            size="medium"
                            color="secondary"
                        >
                            <ListItemIcon>
                                <ArrowBackIcon />
                            </ListItemIcon>
                            Button
                        </CommonButton>
                    </Grid>
                    <Grid item xs={3}>
                        <CommonButton
                            variant="contained"
                            size="medium"
                            color="secondary"
                            sx={arrowButtonStyles}
                        >
                            <ListItemIcon>
                                <ArrowBackIcon sx={{width: '30px'}}/>
                            </ListItemIcon>
                            
                        </CommonButton>
                    </Grid>
                    <Grid item xs={3}>
                        <CommonButton
                            variant="contained"
                            size="medium"
                            color={"secondary"}
                        >
                            Button
                            <ListItemIcon>
                                <PlusOneIcon sx={{ color: '#005786', backgroundColor: '#D8E6F0', borderRadius:'10px', marginLeft: '4px', size: 'small' }} />
                            </ListItemIcon>
                        </CommonButton>
                    </Grid>
                    <Grid item xs={3}>
                        <CommonButton
                            variant="contained"
                            size="medium"
                            color="secondary"
                        >
                            Button
                            
                        </CommonButton>
                    </Grid>                       
                </Grid>
            </Box>

            <h3>Data Grid Status Filter</h3>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        Default, <br /> hover, <br /> pressed <br /> and focused
                    </Grid>
                    <Grid item xs={3}>
                        <CommonButton
                            variant="contained"
                            size="medium"
                            color="secondary"
                            boxshadow={'none'}
                            sx={filterButtonStyles}
                        >
                            Button <span>4</span>
                        </CommonButton>
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    )
}

export default Library;